'use strict';

const _ = require('lodash');
const Moment = require('moment');

function UploaderPageController(
  $scope,
  $timeout,
  $state,
  $window,
  IdentityService,
  IntercomService,
  TopControlsStore,
  TopControlsActions,
  PlanStore,
  OrganizationStore,
  AnalyticsService,
  AppDialogsActions,
  UploaderStore,
  IngestorService,
  DropdownService
  ) {

  const vm = this;

  const user = IdentityService.getUser();
  const supportSite = '//support.skycatch.com/hc/en-us/categories/201644828-Skycatch-Dashboard';
  vm.canPlanChat = PlanStore.get('orgPlan') && PlanStore.get('orgPlan').isEnabled && PlanStore.checkFeature('organization', 'chat_support');
  vm.hasMultipleOrganizations = user && user.organizations ? user.organizations.length > 1 : false;
  vm.isBetaUser = IdentityService.isBetaUser();


  const ingestorContainer = document.getElementById('ingestor-main-container');
  if (ingestorContainer) {
    IngestorService.setShowOnInit(true)
    ingestorContainer.style.display = 'block';
    IngestorService.sendShowApp()
    IngestorService.sendHideTopbarWidget()
    IngestorService.sendShowTopbarWidget()
    // IngestorService.
  }
  // garbage collect the onClick event listener when scope is destroyed
  $scope.$on('$destroy', function () {
    if(ingestorContainer) {
      ingestorContainer.style.display = 'none';
      IngestorService.sendHideApp()
      IngestorService.sendHideTopbarWidget()
    }
  }.bind(this));

  vm.toggleDataViewer = (viewState) => {
    // send to ingestor
    IngestorService.sendStateChange(viewState)
    vm.currentDataView = vm.dataViews[viewState];
  };

  vm.dataViews = {
    step0: {
      label: 'New Dataset'
    },
    step1: {
      label: 'New Dataset (Step 1 of 2)'
    },
    step2: {
      label: 'New Dataset (Step 2 of 2)',
      leftIcon: 'fa-icon-arrow-left',
      fn: vm.toggleDataViewer.bind(vm, 'step1')
    },
    uploading: {
      label: 'New Dataset (Uploading)'
    },
    processing: {
      label: 'New Dataset (Processing)'
    }
  };

  vm.currentDataView = vm.dataViews.step0

    /* custom logo */
  vm.brandConfig = OrganizationStore.getBrandConfig();
  /* /custom logo */

  vm.openChat = () => {

    IntercomService.show();
    DropdownService._closeGroup('topnav')
  };

  vm.openSupport = () => {

    $window.open(supportSite, '_blank');
  };

  vm.goToSite = () => {
    vm.showSpinner = true
    $state.go('dash.map')
  }

  vm.openSettings = () => {

    $state.go('settings.myProfile');
  };

  vm.changeOrg = () => {

    $state.go('select-organization');
  };

  vm.logout = () => {
    $state.go('logout', {}, {
      location: false
    });
  };

  vm.convertToSubscription = () => {

    const subscription = PlanStore.get('externalSubscription');

    AnalyticsService.track('[CORE] Subscription', 'Enter Flow', {
      'remaining_days': (new Date(subscription.trial_end) - new Date() / 1000) / (60 * 60 * 24),
      'state': $state.current.name
    });
    AppDialogsActions.GetSelectPlanPage.dispatch();
  };

  /**
 * Handler for the our component store change, updates the current 3d toggle state
 */
  vm._handleIngestorStateChange = () => {

    vm.newSiteName = UploaderStore.get('siteName')
    const state = UploaderStore.get('state')
    const date = UploaderStore.get('captureDate') && UploaderStore.get('captureDate') > 0 ? new Date(UploaderStore.get('captureDate')) : null
    vm.newCaptureDate = date ? Moment(date).format('MMMM Do, YYYY') : null
    vm.currentDataView = vm.dataViews[state];
    vm.updateAutohideLayout();
  };

  vm.updateAutohideLayout = () => {

    $timeout(() => {

      // we need to give angular a tick to show or hide its elements based on the site permissions
      $scope.$broadcast('RELOAD_AUTOHIDE');
    });
  };

  vm._handlePlanStoreChange = _.debounce(() => {

    const customer = PlanStore.get('externalCustomer');
    const subscription = PlanStore.get('externalSubscription');
    vm.hasEnabledPlan = PlanStore.get('orgPlan').isEnabled;
    if (subscription) {
      vm.daysLeft = (new Date(subscription.trial_end) - new Date() / 1000) / (60 * 60 * 24);
      if (subscription.status === 'in_trial' && customer.card_status !== 'valid') {
        vm.planUpsellState = true;
      }
      else if (subscription.status === 'cancelled') {
        vm.daysLeft = 0;
        vm.planUpsellState = true;
      }
      else {
        vm.planUpsellState = false;
      }
    }

    vm.canPlanChat = PlanStore.get('orgPlan').isEnabled && PlanStore.checkFeature('organization', 'chat_support');
  }, 900);

  PlanStore.on(PlanStore.Events.Changed, vm._handlePlanStoreChange.bind(vm), $scope);
  UploaderStore.on(UploaderStore.Events.Changed, vm._handleIngestorStateChange.bind(vm), $scope);
}

UploaderPageController.$inject = [
  '$scope',
  '$timeout',
  '$state',
  '$window',
  'IdentityService',
  'IntercomService',
  'TopControlsStore',
  'TopControlsActions',
  'PlanStore',
  'OrganizationStore',
  'AnalyticsService',
  'AppDialogsActions',
  'UploaderStore',
  'IngestorService',
  'DropdownService'
]

module.exports = UploaderPageController;



// WEBPACK FOOTER //
// ./src/app/uploader/UploaderPageController.js